import React, { useEffect } from "react";

import { useVehicleSelection } from "../../providers/VehicleSelectionContext.tsx";
import { Product as ProductType } from "../../types/Product";
import { Image } from "./Image.tsx";

interface ProductProps {
  product: ProductType;
}

const Product: React.FC<ProductProps> = ({ product }) => {
  const { selectedOptionDetails, handleOptionDetailChange } =
    useVehicleSelection();

  const onQuantityChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    handleOptionDetailChange(product.optionKey, {
      quantity: e.target.value ? Number(e.target.value) : 1,
    });
  };

  useEffect(() => {
    // Initialize quantity if not set
    if (
      product.entry.entry_customer_quantity &&
      !selectedOptionDetails[product.optionKey]?.quantity
    ) {
      handleOptionDetailChange(product.optionKey, {
        quantity: Number(product.entry.customer_min_quantity) || 1,
      });
    }
  }, [
    handleOptionDetailChange,
    product.entry,
    product.optionKey,
    selectedOptionDetails,
  ]);

  return (
    <div className="bg-white rounded-lg pl-2 pt-4 pr-2 pb-2 text-left h-full flex flex-col">
      {product.image_url && (
        <Image
          src={product.image_url}
          alt={product.name}
          className={"mb-2"}
        ></Image>
      )}
      <div className="text-sm mb-4 font-semibold flex-grow">
        {product.name.toUpperCase()}
      </div>

      {product.entry?.entry_customer_quantity === "on" && (
        <div className="flex items-center gap-2 text-sm mb-3">
          Quantity:
          <input
            className="bg-gray-100 p-3 py-2 border-0 border-b-2 border-black focus:outline-none focus:border-black text-gray-900 text-left basis-full "
            type={"number"}
            min={product.entry.customer_min_quantity || 1}
            max={product.entry.customer_max_quantity || undefined}
            step={product.entry.customer_quantity_increment || 1}
            placeholder={"" + (product.entry.customer_min_quantity || 1)}
            value={selectedOptionDetails[product.optionKey]?.quantity}
            onChange={onQuantityChange}
          />
        </div>
      )}

      {product.price !== null && (
        <p className="text-sm">${product.price.toFixed(2)}</p>
      )}
    </div>
  );
};

export default Product;
